/**
 * browser module.
 * @author Rick 封装对浏览器环境的判断
 * @module browser
 */
export {
    isFB,
    isIE,
    getIEVersion,
    isAndroid,
    isBlackBerry,
    isIOS,
    isWindows,
    isMac,
    isIpad,
    isWx,
    isWX,
    isSafari,
    isNN,
    isMobileNN,
    isMacNN,
    isPCNN,
    isIpadNN,
    isDesktopNN,
    isNNPlatform,
    isMobile,
    isNnPlatform,
    isMobileUA,
    isMobileQQ,
    getClientLang,
    isMoomoo,
    isFTNN,
    isWXWork,
    isWXMiniAPP,
    isWXMiniAPPAsync,
    isWeibo,
    isTwitter,
    isQQBrowser,
    isQQMiniAPP,
    isAlMiniAPP,
    isBdMiniAPP,
    isByteMiniAPP,
    isMiniAPP,
    getNNVersion,
    compareVersion,
    compareVersionV2,
    laterThanVersion,
    laterThanClient,
    laterThanVersionV2,
    getClientSkin,
    getClientType
};

const AndroidNiuniu = 13;
const AndroidMooMoo = 53;
const IOSNiuniu = 12;
const IOSMooMoo = 52;
const MacNiuniu = 11;
const MacMooMoo = 51;
const MacQtNiuniu = 111;
const MacQtMooMoo = 121;
const WindowsNiuniu = 10;
const WindowsMooMoo = 50;
const PCRoa = 70;
const PCOms = 80;
const WindowsQtNiuniu = 110;
const WindowsQtMooMoo = 120;
const WindowsQtRoa = 130;
const WindowsQtOms = 140;
const LinuxQtNiuniu = 114;
const LinuxQtMooMoo = 124;

// Mac客户端类型
const ClientTypeListMac = [MacNiuniu, MacMooMoo, MacQtNiuniu, MacQtMooMoo];
// Windows客户端类型
const ClientTypeListWin = [WindowsNiuniu, WindowsMooMoo, PCRoa, PCOms, WindowsQtNiuniu, WindowsQtMooMoo, WindowsQtRoa, WindowsQtOms];
// Linux客户端类型
const ClientTypeListLinux = [LinuxQtNiuniu, LinuxQtMooMoo];
// 移动端牛牛客户端和moomoo类型
const ClientTypeListNiuniuMoomooMobile = [IOSNiuniu, AndroidNiuniu, IOSMooMoo, AndroidMooMoo];
// 牛牛客户端类型
const ClientTypeListNiuniu = [WindowsNiuniu, MacNiuniu, IOSNiuniu, AndroidNiuniu, WindowsQtNiuniu, MacQtNiuniu, LinuxQtNiuniu];
// Moomoo客户端类型
const ClientTypeListMoomoo = [WindowsMooMoo, MacMooMoo, IOSMooMoo, AndroidMooMoo, WindowsQtMooMoo, MacQtMooMoo, LinuxQtMooMoo];

/**
 * 是否是指定ClientType范围内的类型
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否移动端牛牛客户端webview
 */
function isTargetClientType(clientTypeList, clientType) {
    if (clientTypeList.includes(clientType)) {
        return true;
    } else { 
        return false;
    }
}

/**
 * [getUA 获取ua]
 * @private
 * @param  {Object} args [类数组，是各个方法的arguments 对象]
 * @return {String}      [userAgent]
 */
function getUA(args) {
    if (args && args.length > 0 && args[0] !== undefined) {
        return args[0] || '';
    }
    let userAgent = '';

    try {
        userAgent = navigator.userAgent;
    } catch (e) {
        userAgent = '';
    }

    return userAgent;
}

/**
 * 判断是否IE浏览器
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 是否为IE浏览器
 */
function isIE() {
    let userAgent = getUA(arguments);
    return userAgent && /msie|Trident.*rv/i.test(userAgent);
}

/**
 * 获取IE版本，返回值包括7,8,9,10,11
 * @function
 * @static
 * @since 1.0.0
 * @returns {string} IE版本，7,8,9,10,11，非IE时返回0
 */
function getIEVersion() {
    let userAgent = getUA(arguments);
    if (userAgent && isIE(userAgent)) {
        let rv = null;
        let ua, re;
        if (/msie/i.test(userAgent)) {
            ua = userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        } else if (/Trident/i.test(userAgent)) {
            ua = userAgent;
            re = new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }
        return rv;
    }
    return 0;
}

/**
 * 判断当前系统的是否为Android
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 当前系统的是否为Android
 */
function isAndroid() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/Android/i) ? true : false;
}


/**
 * 判断当前系统的是否为BlackBerry
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 当前系统的是否为BlackBerry
 */
function isBlackBerry() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/BlackBerry/i) ? true : false;
}

/**
 * 判断当前系统的是否为ios
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 当前系统的是否为ios
 */
function isIOS() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
}

/**
 * 判断当前系统的是否为ios
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 当前系统的是否为ios
 */
function isWindows() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.indexOf('Windows NT') > -1 && !isAndroid(userAgent) && !isIOS(userAgent);
}

/**
 * 判断当前系统的是否为mac
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 当前系统的是否为mac
 */
function isMac() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.indexOf('Macintosh') > -1 && !isAndroid(userAgent) && !isIOS(userAgent) ? true : false;
}

/**
 * 判断当前系统的是否为ipad
 * @function
 * @static
 * @since 2.11.0
 * @returns {Boolean} 当前系统的是否为ipad
 */
function isIpad() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/iPad/i) ? true : false;
}

/**
 * 判断当前是否为微信webview
 * @function
 * @static
 * @since 1.0.0
 * @deprecated 与isWX方法功能相同，建议使用isWX方法，此处仅做兼容处理
 * @returns {Boolean} 是否为微信webview
 */
function isWx() {
    let userAgent = getUA(arguments);
    return isWX(userAgent);
}

/**
 * 判断当前是否为微信webview
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 是否为微信webview
 */
function isWX() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/micromessenger/i) ? true : false;
}

/**
 * 判断当前是否为企业微信webview,注意，企业weixin也是微信的一类
 * @function
 * @static
 * @since 2.5.0
 * @returns {Boolean} 是否为企业微信webview
 */
function isWXWork() {
    let userAgent = getUA(arguments);
    return userAgent && isWX(userAgent) && /wxwork/i.test(userAgent);
}

/**
 * 判断当前是否为手Q webview
 * @function
 * @static
 * @since 1.4.0
 * @returns {Boolean} 是否为手Q webview
 */
function isMobileQQ() {
    let ua = getUA(arguments);
    return /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(ua) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(ua);
}

/**
 * 判断当前是否Safari浏览器
 * @function
 * @static
 * @since 1.0.0
 * @returns {Boolean} 是否Safari浏览器 webview
 */
function isSafari() {
    let userAgent = getUA(arguments);
    // safari中不会存在chrome的ua
    return userAgent && userAgent.match(/safari/i) && !userAgent.match(/chrome/i) ? true : false;
}

/**
 * 判断当前是否移动端牛牛或moomoo客户端webview
 * @function
 * @static
 * @since 1.0.0
 * @deprecated 与isMobileNN方法功能相同，建议使用更加明确的isMobileNN方法
 * @returns {Boolean} 是否移动端牛牛或moomoo客户端webview
 */
function isNN() {
    let userAgent = getUA(arguments);
    return isMobileNN(userAgent);
}

/**
 * 旧版判断当前是否移动端牛牛或moomoo客户端webview
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否移动端牛牛或moomoo客户端webview
 */
function _isMobileNN() {
    let userAgent = getUA(arguments);
    return userAgent && (userAgent.match(/futunn/i) && userAgent.match(/Android|iPhone|iPad|iPod/i)) ? true : false;
}

/**
 * 判断当前是否移动端牛牛或moomoo客户端webview
 * @function
 * @static
 * @since 1.1.0
 * @returns {Boolean} 是否移动端牛牛或moomoo客户端webview
 */
function isMobileNN() {
    const ClientTypeList = [...ClientTypeListNiuniuMoomooMobile];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType)
    } else {
        return _isMobileNN(...arguments);
    }
}
/**
 * 旧版判断当前是否MAC端牛牛或moomoo客户端webview
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否MAC端牛牛或moomoo客户端webview
 */
function _isMacNN() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/futunn_mac/i) ? true : false;
}

/**
 * 判断当前是否MAC端牛牛或moomoo客户端webview
 * @function
 * @static
 * @since 1.3.0
 * @returns {Boolean} 是否MAC端牛牛或moomoo客户端webview
 */
function isMacNN() {
    const ClientTypeList = [...ClientTypeListMac];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType)
    } else {
        return _isMacNN(...arguments);
    }
}

/**
 * 旧版判断当前是否windows端牛牛或者moomoo客户端webview
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否windows端牛牛或者moomoo客户端webview
 */
function _isPCNN() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/futunn_pc/i) ? true : false;
}

/**
 * 判断当前是否windows端牛牛或者moomoo客户端webview
 * @function
 * @static
 * @since 1.3.0
 * @returns {Boolean} 是否windows端牛牛或者moomoo客户端webview
 */
function isPCNN() {
    const ClientTypeList = [...ClientTypeListWin];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType);
    } else {
        return _isPCNN(...arguments);
    }
}

/**
 * 旧版判断当前是否桌面端牛牛，即为MAC或者PC端、linux端牛牛或moomoo
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否桌面端牛牛或moomoo
 */
function _isDesktopNN() {
    let userAgent = getUA(arguments);
    return (userAgent.match(/futunn/i) && !userAgent.match(/Android|iPhone|iPad|iPod/i)) ? true : false;
}

/**
 * 判断当前是否桌面端牛牛，即为MAC或者PC端、linux端牛牛或moomoo
 * @function
 * @static
 * @since 1.1.0
 * @returns {Boolean} 是否桌面端牛牛或moomoo
 */
function isDesktopNN() {
    const ClientTypeList = [...ClientTypeListMac, ...ClientTypeListWin, ...ClientTypeListLinux];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType);
    } else {
        return _isDesktopNN(...arguments);
    }
}

/**
 * 判断当前是否是ipad牛牛或者moomoo
 * @function
 * @static
 * @since 2.11.0
 * @returns {Boolean} 是否是Ipad牛牛或者moomoo
 */
function isIpadNN() {
    let userAgent = getUA(arguments);
    return isNNPlatform(...arguments) && isIpad(userAgent) ? true : false;
}

/**
 * 获取ClientType值，2.20.0新版ua中才有，否则返回''
 * @function
 * @static
 * @since 2.20.0
 * @returns 返回ClientType值
 */
function getClientType() {
    let userAgent = getUA(arguments);
    if(!userAgent) return ''; 
    const matchList = userAgent.match(/ClientType\/(\d+)/);
    if(!matchList) return ''; 
    const clientType = matchList && Number(matchList[1]) || '';
    if(typeof clientType === "number") {
        return clientType;
    } else {
        return '';
    }
}

/**
 * 判定是否是有ClientType字符串的新版ua，是返回true，否则返回false
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean}
 */
function hasClientType() {
    let userAgent = getUA(arguments);
    if(!userAgent) return false; 
    return /ClientType\/(\d+)/.test(userAgent);
}

/**
 * 旧版判断当前是否牛牛或moomoo客户端webview，包括各个平台
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否牛牛或moomoo客户端webview，包括各个平台
 */
function _isNNPlatform() {
    let userAgent = getUA(arguments);
    return userAgent && userAgent.match(/futunn/i) ? true : false;
}

/**
 * 判断当前是否牛牛或moomoo客户端webview，包括各个平台
 * @function
 * @static
 * @since 1.1.0
 * @returns {Boolean} 是否牛牛或moomoo客户端webview，包括各个平台
 */
function isNNPlatform() {
    const ClientTypeList = [...ClientTypeListNiuniu, ...ClientTypeListMoomoo];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType);
    } else {
        return _isNNPlatform(...arguments);
    }
}

/**
 * 判断当前是否牛牛客户端webview，包括各个平台
 * @function
 * @static
 * @since 1.1.0
 * @deprecated 与isNNPlatform方法功能相同，建议使用isNNPlatform方法，此处仅做兼容处理
 * @returns {Boolean} 是否牛牛客户端webview，包括各个平台
 */
function isNnPlatform() {
    let userAgent = getUA(arguments);
    return isNNPlatform(userAgent);
}

/**
 * 判断当前是否为移动客户端浏览器环境
 * @function
 * @static
 * @since 1.5.0
 * @returns {Boolean} 是否为移动客户端浏览器环境
 */
function isMobile() {
    let userAgent = getUA(arguments);
    return userAgent.match(/(blackberry|configuration\/cldc|hp |hp-|htc |htc_|htc-|iemobile|kindle|midp|mmp|motorola|mobile|nokia|opera mini|opera |Googlebot-Mobile|YahooSeeker\/M1A1-R2D2|android|iphone|ipod|mobi|palm|palmos|pocket|portalmmm|ppc;|smartphone|sonyericsson|sqh|spv|symbian|treo|up.browser|up.link|vodafone|windows ce|xda |xda_)/i) ? true : false;
}

/**
 * 判断当前是否为移动客户端浏览器环境
 * @function
 * @static
 * @since 1.5.0
 * @deprecated 与isMobile方法功能相同，建议使用更加明确的isMobile方法,此处仅做兼容处理
 * @returns {Boolean} 是否为移动客户端浏览器环境
 */
function isMobileUA() {
    let userAgent = getUA(arguments);
    return isMobile(userAgent);
}

/**
 * 旧版判断当前是否为是否为美分环境moomoo客户端
 * @function
 * @static
 * @since 2.20.0
 * @returns {Boolean} 是否为是否为美分环境moomoo客户端
 */
function _isMoomoo() {
    let userAgent = getUA(arguments);
    return userAgent.match(/MooMoo/i) ? true : false;
}

/**
 * 判断当前是否为是否为美分环境moomoo客户端
 * @function
 * @static
 * @since 2.4.0
 * @returns {Boolean} 是否为是否为美分环境moomoo客户端
 */
function isMoomoo() {
    const ClientTypeList = [...ClientTypeListMoomoo];
    const ClientType = getClientType(...arguments);
    if(hasClientType(...arguments)) {
        return isTargetClientType(ClientTypeList, ClientType);
    } else {
        return _isMoomoo(...arguments);
    }
}

/**
 * 判断当前是否为 【牛牛客户端】
 * @return {Boolean} [判断当前为牛牛客户端而不是moomoo客户端]
 */
function isFTNN() {
    let userAgent = getUA(arguments);
    return isNNPlatform(userAgent) && (isMoomoo(userAgent) === false);
}

/**
 * 获取客户端语言
 * @function
 * @static
 * @since 2.1.0
 * @param {string} [from] 解析来源 nn | wx | browser | all
 * @returns {string} 客户端语言 zh-cn | zh-hk | en-us | jp | '' 判断en从2.3.0开始支持。从2.4.4开始匹配到zh-tw将返回zh-hk,2.17.0开始支持jp
 */
function getClientLang(from) {
    if (!from) from = 'nn';
    let nnLang = '';
    let wxLang = '';
    let uaLang = '';
    let langMap = {
        en: 'en-us',
        'zh-tw': 'zh-hk'
    };
    let userAgent = getUA();
    // 牛牛内的语言要取ua中的语言，
    // navigator.language是系统的语言类型，但是牛牛客户端不一定支持英文
    const nnRegexp = /CliLang\/(\w*(?:[\_\-]{1}\w*)?)/i;
    const nnMatch = userAgent.match(nnRegexp);
    if (nnMatch && nnMatch.length >= 2) {
        nnLang = nnMatch[1].toLowerCase();
        if (nnLang !== 'zh-cn' && nnLang !== 'zh-hk' && nnLang !== 'en-us' && nnLang !== 'ja') {
            nnLang = langMap[nnLang] || '';
        }
    }

    // 如果只取牛牛或moomoo
    if (from === 'nn') {
        return nnLang;
    }

    const wxRegexp = /Language\/(\w*(?:[\_\-]{1}\w*)?)/i;
    const wxMatch = userAgent.match(wxRegexp);
    if (wxMatch && wxMatch.length >= 2) {
        wxLang = wxMatch[1].toLowerCase().replace(/_/g, '-');
        if (wxLang !== 'zh-cn' && wxLang !== 'zh-hk' && wxLang !== 'en-us' && wxLang !== 'ja') {
            wxLang = langMap[wxLang] || '';
        }
    }

    // 如果只取微信
    if (from === 'wx') {
        return wxLang;
    }

    // 从浏览器取语言
    uaLang = navigator.language;
    if (uaLang) {
        uaLang = uaLang.toLowerCase().replace(/_/g, '-');

        if (uaLang !== 'zh-cn' && uaLang !== 'zh-hk' && uaLang !== 'en-us' && uaLang !== 'ja') {
            // 如果navigator.language存在`en-`，统一认为是English
            if (uaLang.indexOf('en-') !== -1) {
                uaLang = 'en';
            }
            uaLang = langMap[uaLang] || '';
        }
    }

    // 如果只取浏览器
    if (from === 'browser') {
        return uaLang;
    }

    return nnLang || wxLang || uaLang;

}

/**
 * 判断当前是否为facebook webview环境中
 * @function
 * @static
 * @since 2.2.0
 * @returns {Boolean} 是否为facebook webview环境
 */
function isFB() {
    let userAgent = getUA(arguments);
    return /fb/gi.test(userAgent);
}

/**
 * 判断当前是否为微博 webview环境中
 * @function
 * @static
 * @since 2.7.0
 * @returns {Boolean} 是否为微博 webview环境
 */
function isWeibo() {
    let userAgent = getUA(arguments);
    return /weibo/gi.test(userAgent);
}

/**
 * 判断当前是否为twitter webview环境中
 * @function
 * @static
 * @since 2.7.0
 * @returns {Boolean} 是否为twitter webview环境
 */
function isTwitter() {
    let userAgent = getUA(arguments);
    return /twitter/gi.test(userAgent);
}

/**
 * 判断当前是否在qq浏览器客户端中，包括电脑和手机端
 * @function
 * @static
 * @since 2.7.0
 * @returns {Boolean} 是否为qq浏览器客户端
 */
function isQQBrowser() {
    let userAgent = getUA(arguments);
    return /qqbrowser/gi.test(userAgent) && !isMobileQQ(userAgent) && !isWX(userAgent);
}

/**
 * 判断当前是否在QQ小程序里面
 * @function
 * @static
 * @since 2.16.0
 * @returns {Boolean} 是否在QQ小程序
 */
 function isQQMiniAPP() {
    let userAgent = getUA(arguments);
    return /miniProgram/gi.test(userAgent) && /QQ/gi.test(userAgent);
}

/**
 * 判断当前是否在支付宝小程序里面
 * @function
 * @static
 * @since 2.16.0
 * @returns {Boolean} 是否在支付宝小程序
 */
 function isAlMiniAPP() {
    let userAgent = getUA(arguments);
    return /miniProgram/gi.test(userAgent) && /AlipayClient/gi.test(userAgent);
}

/**
 * 判断当前是否在百度小程序里面
 * @function
 * @static
 * @since 2.16.0
 * @returns {Boolean} 是否在百度小程序
 */
 function isBdMiniAPP() {
    let userAgent = getUA(arguments);
    return /swan\//gi.test(userAgent) || (typeof window !== 'undefined' && /^webswan-/.test(window.name));
}

/**
 * 判断当前是否在字节小程序里面
 * @function
 * @static
 * @since 2.16.0
 * @returns {Boolean} 是否在字节小程序
 */
 function isByteMiniAPP() {
    let userAgent = getUA(arguments);
    return /ToutiaoMicroApp/gi.test(userAgent);
}

/**
 * 判断当前是否在微信 或 QQ 或 支付宝 或 百度 或 字节小程序里面
 * @function
 * @static
 * @since 2.16.0
 * @returns {Boolean} 判断当前是否在微信 或 QQ 或 支付宝 或 百度 或 字节小程序里面
 */
 function isMiniAPP() {
    let wx = isWXMiniAPP(...arguments);
    let qq = isQQMiniAPP(...arguments);
    let al = isAlMiniAPP(...arguments);
    let bd = isBdMiniAPP(...arguments);
    let byte = isByteMiniAPP(...arguments);
    let res = wx || qq || al || bd || byte;
    return res;
}

/**
 * 当前是否为微信小程序，微信7.0.0及以上使用没有问题
 * @function
 * @since 2.8.0
 * @static
 * @return {Boolean} [当前是否为微信小程序]
 */
function isWXMiniAPP() {
    let userAgent = getUA(arguments);
    if (!isWX(userAgent)){
        return false;
    }

    return /miniProgram/gi.test(userAgent);
}

/**
 * 异步判断当前是否为微信小程序，不存在兼容问题
 * @function
 * @since 2.8.0
 * @static
 * @param {Function} cb (isMiniApp) [cb为接受结果的方法，参数为结果]
 * @return {void}
 */
function isWXMiniAPPAsync(cb) {

    if(Object.prototype.toString.call(cb) !== '[object Function]'){
        return false;
    }

    if(!isWX()){
        cb(false);
    }

    /**
     * web-view下的页面内
     * @return {void}
     */
    function ready() {
        var isMiniApp = window.__wxjs_environment === 'miniprogram' || isWXMiniAPP();
        cb(isMiniApp);
    }

    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', ready, false);
    } else {
        ready();
    }
}

/**
 * 获取牛牛或moomoo版本号，非牛牛或moomoo号，结果为''
 * @function
 * @since 2.9.0
 * @static
 * @return {string} [牛牛或moomoo版本号或者为'']
 */
function getNNVersion(){
    const Cliversion = getNNVersionClientversion(...arguments);
    const NNVersionFutunn = _getNNVersion(...arguments);
    return Cliversion === '' ? NNVersionFutunn : Cliversion;
}

/**
 * 通过"clientversion"前缀获取牛牛或moomoo版本号，非牛牛或moomoo号，结果为''
 * @function
 * @since 2.20.0
 * @static
 * @return {string} [牛牛或moomoo版本号或者为'']
 */
function getNNVersionClientversion(){
    let userAgent = getUA(arguments);
    if(!userAgent) return ''; 

    if(!isNNPlatform(userAgent)) return '';

    const cliversionList = userAgent.match(/clientversion\/([\d\.]+)/i);
    if(!cliversionList) return ''; 

    const clientType = cliversionList && cliversionList[1] || '';
    return clientType;
}

/**
 * 通过"futunn_"前缀获取牛牛版本号，非牛牛号，结果为''
 * @function
 * @since 2.20.0
 * @static
 * @return {string} [牛牛版本号或者为'']
 */
function _getNNVersion(){
    let userAgent = getUA(arguments);
    if(!isNNPlatform(userAgent)){
        return '';
    }

    let res = /futunn_(?:mac|iphone|android|pc)\/(\d+\.\d+.\d+)/i.exec(userAgent);

    if(res) {
        return res[1] || '';
    }

    return '';
}

/**
 * 比较版本号的大小，客户端版本号x.y.z，此方法会优先比较前面版本（x->y->z）的大小。返回值1表示a版本大于b，返回0表示a版本等于b，返回-1表示a版本小于b
 * @param a {string}
 * @param b {string}
 * @returns {*}
 */
function compareVersion(a, b) {
    var i;
    var len;

    if (typeof a + typeof b !== 'stringstring') {
        return false;
    }

    a = a.split('.');
    b = b.split('.');
    i = 0;
    len = Math.max(a.length, b.length);

    for (; i < len; i++) {
        if ((a[i] && !b[i] && parseInt(a[i]) > 0) || (parseInt(a[i]) > parseInt(b[i]))) {
            return 1;
        } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || (parseInt(a[i]) < parseInt(b[i]))) {
            return -1;
        }
    }

    return 0;
}

/**
 * 比较版本号的大小，客户端版本x.y.z中的z会一直递增，所以此方法只判断z的大小。返回值1表示a版本大于b，返回0表示a版本等于b，返回-1表示a版本小于b
 * @param a {string} x.y.z
 * @param b {string} x.y.z
 * @returns {number}
 */
function compareVersionV2(a, b) {
    if (typeof a !== 'string' || typeof b !== 'string') {
        throw new Error('参数必须是字符串类型');
    }
    a = a.split('.');
    b = b.split('.');
    if (a.length !== 3 || b.length !== 3) {
        throw new Error('参数必须是x.y.z格式');
    }

    a = parseInt(a[2]);
    b = parseInt(b[2]);
    if(a>b){
        return 1;
    }else if(a<b){
        return -1;
    }else if(a===b){
        return 0;
    }
    throw new Error('参数格式错误');
}

/**
 * 是否大于或等于某个版本号，客户端版本号x.y.z，此方法会优先比较前面版本（x->y->z）的大小。非牛牛环境下返回false
 * @param ver
 * @param userAgent UA信息默认会去取`navigator.userAgent`
 * @deprecated 通过laterThanClient替换
 * @returns {boolean}
 */
function laterThanVersion(ver, userAgent) {
    if (!ver) {
        return false;
    }
    const res = compareVersion(ver, getNNVersion(userAgent));
    if (typeof res === 'boolean') {
        return res;
    }
    return res >= 0;
}

/**
 * 客户端版本号是否大于或等于某个版本号，当isXYZFormat为true，客户端版本号x.y.z，此方法会优先比较前面版本（x->y->z）的大小；当isXYZFormat为true，客户端版本号z，只会比较z版本大小。非牛牛环境下返回false
 * @param {Object} options - 配置项
 * {
 *   // 传入的比较版本
 *   ver: '10.18.1262', 
 *   // UA信息，默认会去取`navigator.userAgent`
 *   userAgent: 'Mozilla/5.0 (Linux; Android 10; MIX 3 Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/81.0.4044.138 Mobile Safari/537.36 FutuNN_Android/10.18.1262 RequestSource/Http CliLang/zh-cn ClientFont/1.0 (quote:1; trade:1; news:1; nnc:1; sns:1; other:1) ClientSkinType/3 AppType/NiuNiu RequestSource/WebView ClientChannelType/404', 传入的比较版本
 *   // ver参数是否是x.y.z的格式还是值z格式，不传默认false，isXYZFormat为true比较顺序为（x->y->z），isXYZFormat为false，只比较z版本，ver参数只要传入z版本
 *   isXYZFormat: false
 * }
 * @returns {boolean}
 */
function laterThanClient(options) {
    if (!options) {
        throw new Error('options参数必传')
    }
    let {
        ver,
        userAgent,
        isXYZFormat
    } = options
    if (!ver) {
        throw new Error('ver参数必传')
    }
    if(typeof ver !== 'string') {
        throw new Error('ver参数必须是字符串类型');
    }
    if(isXYZFormat) {
        if (!/^[0-9]+\.[0-9]+\.[0-9]+$/.test(ver)) {
            throw new Error('isXYZFormat为true时，参数必须是x.y.z格式')
        }
    } else {
        if (!/^[0-9]+$/.test(ver)) {
            throw new Error('isXYZFormat为false时，ver参数必须是数字字符串')
        }
    }
    let uaVerStr = getNNVersion(userAgent);
    if(!isXYZFormat) {
        let uaVersionList = uaVerStr.split('.');
        ver = `${uaVersionList[0]}.${uaVersionList[1]}.${ver}`;
    }
    const res = compareVersion(uaVerStr, ver);
    if (typeof res === 'boolean') {
        return res;
    }
    return res >= 0;
}

/**
 * 是否大于或等于某个版本号，只判断x.y.z中z的大小。非牛牛环境下返回false
 * @param ver x.y.z
 * @param userAgent UA信息默认会去取`navigator.userAgent`
 * @deprecated 通过laterThanClient替换
 * @returns {boolean}
 */
function laterThanVersionV2(ver, userAgent) {
    if (!ver) {
        throw new Error('第一个参数（ver）是必传的。')
    }
    const res = compareVersionV2(ver, getNNVersion(userAgent));
    if (typeof res === 'boolean') {
        return res;
    }
    return res >= 0;
}

/**
 * 获取客户端皮肤方法
 * @param userAgent UA信息默认会去取`navigator.userAgent`
 * @returns {Number} 皮肤类型 0:默认/经典 | 1:白色 | 3:黑色 | -1:未知/非牛牛环境
 */
function getClientSkin() {
    let userAgent = getUA(arguments);
    let reg = /ClientSkinType\/(\d+)/gi;
    let matches = reg.exec(userAgent);
    if(matches && matches.length > 1){
        return Number(matches[1])
    }
    return -1
}